export const DOBRA = 'Dobra'
export const DOBRA_BOLD = 'Dobra-Bold'
export const DOBRA_LIGTH = 'Dobra-Book'
